// extracted by mini-css-extract-plugin
export default {"wrapper":"search_tabs-module___wrapper___d7738d5a"};